/* Duck Commander homepage hero carousel only (dc-hero section).
   Brand landing pages use a single static banner — no data-dc-hero-carousel there.
   Opacity-only crossfade (no visibility toggling) keeps last→first wraps seamless. */
(function () {
  if (typeof window === 'undefined') return;

  var TRANSITION_MS = 900;

  function initHero(root) {
    if (!root || root.getAttribute('data-dc-hero-init') === 'true') return;

    var slides = root.querySelectorAll('.dc-hero__slide');
    var dots = root.querySelectorAll('.dc-hero__dot');
    if (slides.length <= 1) return;

    root.setAttribute('data-dc-hero-init', 'true');

    var current = 0;
    var speed = parseInt(root.getAttribute('data-auto-speed'), 10) * 1000 || 5000;
    var timer = null;
    var paused = false;
    var reduceMotion =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    slides.forEach(function (slide, index) {
      slide.setAttribute('aria-hidden', index === 0 ? 'false' : 'true');
    });

    function goTo(index) {
      var next = ((index % slides.length) + slides.length) % slides.length;
      if (next === current) return;

      slides[current].classList.remove('dc-hero__slide--active');
      slides[current].setAttribute('aria-hidden', 'true');
      if (dots[current]) dots[current].classList.remove('dc-hero__dot--active');

      current = next;

      slides[current].classList.add('dc-hero__slide--active');
      slides[current].setAttribute('aria-hidden', 'false');
      if (dots[current]) dots[current].classList.add('dc-hero__dot--active');
    }

    function schedule() {
      clearTimeout(timer);
      if (reduceMotion || paused) return;
      timer = setTimeout(function () {
        if (!paused) goTo(current + 1);
        schedule();
      }, speed);
    }

    function restartAutoplay() {
      clearTimeout(timer);
      schedule();
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.getAttribute('data-index'), 10));
        restartAutoplay();
      });
    });

    root.addEventListener('mouseenter', function () {
      paused = true;
      clearTimeout(timer);
    });

    root.addEventListener('mouseleave', function () {
      paused = false;
      schedule();
    });

    root.addEventListener('focusin', function () {
      paused = true;
      clearTimeout(timer);
    });

    root.addEventListener('focusout', function (e) {
      if (!root.contains(e.relatedTarget)) {
        paused = false;
        schedule();
      }
    });

    schedule();
  }

  function initAll(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-dc-hero-carousel]').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
